<div class="inline-flex w-full">
  @if (type === 'tabsWithURL') {
    <a
      *ngFor="let item of items"
      [routerLink]="item.url"
      class="px-4 py-2 -mb-px rounded-t border"
      [ngClass]="
        activeTab() === item.url?.split('/').at(-1)
          ? 'border-b-transparent border-gray-600 bg-white font-semibold text-gray-900'
          : 'border-t-transparent border-l-transparent border-r-transparent border-b border-gray-600 underline text-neutral-dark'
      ">
      {{ item.title }}
    </a>
  } @else if (type === 'tabsWithButtons') {
    @for (item of items; track item.id) {
      <div
        role="button"
        (click)="selectTab(item.id)"
        class="px-4 py-2 -mb-px rounded-t border cursor-pointer"
        [ngClass]="
          activeTab() === item.id
            ? 'border-b-transparent border-gray-600 bg-white font-semibold text-gray-900'
            : 'border-t-transparent border-l-transparent border-r-transparent border-b border-gray-600 underline text-neutral-dark'
        ">
        {{ item.title }}
      </div>
    }
  }
</div>
<div class="border-t border-gray-600"></div>
<ng-content></ng-content>
